import { useMemo, type ReactNode } from 'react'
import { localeFor, type Language } from '../lib/format'
import { translationsFor } from '../lib/translations'
import { TranslationContext, type TranslationValue } from './translation-context-value'

export function TranslationProvider({ lang, children }: { lang: Language; children: ReactNode }) {
  const value = useMemo<TranslationValue>(() => {
    const catalogue = translationsFor(lang)
    return {
      t: (key: string) => catalogue[key] ?? key,
      lang,
      locale: localeFor(lang),
    }
  }, [lang])

  return <TranslationContext.Provider value={value}>{children}</TranslationContext.Provider>
}
